import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Events from "./pages/Events";
import Donation from "./pages/Donation";
import styled from 'styled-components';

const Container = styled.div`
  height: 100vh;
  overflow-y: auto;
`;
function App() {
  return (
      <Container>
          <BrowserRouter>
              <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/gallery" element={<Events />} />
                  <Route path="/donation" element={<Donation />} />
              </Routes>
          </BrowserRouter>
      </Container>
  );
}

export default App;